export const CENTER = 'center';
export const LEFT = 'left';
export const RIGHT = 'right';
